export { MajorHighlight } from './MajorHighlight';
export { ModerateHighlight } from './ModerateHighlight';
export { MinorHighlight } from './MinorHighlight';
